// extracted by mini-css-extract-plugin
export default {"item-list":"DessertsMobile_item-list__rHUFv","item":"DessertsMobile_item__K+uuv","category-title":"DessertsMobile_category-title__zs9lZ"};